import { AuthContext } from '../hooks/useAuth';
import { useState } from 'react';

export default function ContextProvider({ children }) {
  const [user, setUser] = useState('');
  const [token, setToken] = useState('');
  return (
    <AuthContext.Provider value={{ user, setUser, token, setToken }}>
      {children}
    </AuthContext.Provider>
  );
}
